import React from 'react';
import {
  FaPassport,
  FaIdCard,
  FaFingerprint,
  FaGlobeEurope
} from 'react-icons/fa';

const Services = () => {
  const servicesData = [
    {
      icon: <FaPassport />,
      title: 'Asilo (Primera Solicitud y Renovaciones)',
      description: 'Gestión de citas para solicitud de asilo por primera vez y renovaciones. Cubrimos ambas opciones de forma eficiente.'
    },
    {
      icon: <FaIdCard />,
      title: 'NIE (Asignación y Renovación)',
      description: 'Citas para asignación o renovación de NIE en diferentes provincias. Amplia cobertura en toda España.'
    },
    {
      icon: <FaFingerprint />,
      title: 'Huellas / Toma de Huellas (TIE)',
      description: 'Gestión de citas de huellas para TIE y otros trámites. Conseguimos tu cita confirmada rápidamente.'
    },
    {
      icon: <FaGlobeEurope />,
      title: 'Otras Citas de Extranjería',
      description: 'Consultamos y gestionamos otros tipos de citas según tu caso. Atención personalizada para cada situación.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Nuestros Servicios</h2>
        <p className="services-intro">
          Somos especialistas en la gestión profesional de citas de extranjería en toda España.
          Trabajamos con particulares, abogados y gestorías.
        </p>

        <div className="services-hero-image">
          <img 
            src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200&q=80" 
            alt="Oficina de extranjería en España" 
            className="services-bg-image"
          />
          <div className="services-image-overlay"></div>
        </div>

        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="services-trust">
          <h3 className="services-trust-title">¿Por qué confiar en nosotros?</h3>
          <div className="trust-points">
            <div className="trust-point">
              <span className="trust-check">✓</span>
              <span>5+ años de experiencia en gestión de citas</span>
            </div>
            <div className="trust-point">
              <span className="trust-check">✓</span>
              <span>Más de 1000 clientes atendidos</span>
            </div>
            <div className="trust-point">
              <span className="trust-check">✓</span>
              <span>30+ despachos y gestorías confían en nosotros</span>
            </div>
            <div className="trust-point">
              <span className="trust-check">✓</span>
              <span>Procesos rápidos y transparentes</span>
            </div>
            <div className="trust-point">
              <span className="trust-check">✓</span>
              <span>Atención personalizada</span>
            </div>
          </div>
        </div>

        <div className="services-cta">
          <a href="#contact" className="services-cta-button">
            Solicitar Información
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
